import React, { useState } from "react";
import "./relive.css";
import { FaFilter, FaSearch } from "react-icons/fa";
import { useLanguage } from "../contexts/LanguageContext";

const Relive = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [videos] = useState([
        {
            id: 1,
            videoId: "FZnU4HNavd0",
            title: "🔥 VAZ | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/FZnU4HNavd0/maxresdefault.jpg",
        },
        {
            id: 2,
            videoId: "xp7Ms3YBSKg",
            title: "🌟 Mosh b2b Yazeed | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/xp7Ms3YBSKg/maxresdefault.jpg",
        },
        {
            id: 3,
            videoId: "2cbl_rYr84c",
            title: "🚀 Misha Saied | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/2cbl_rYr84c/maxresdefault.jpg",
        },
        {
            id: 4,
            videoId: "sLXeVVLB1KY",
            title: "🌟 Gate13 | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/sLXeVVLB1KY/maxresdefault.jpg",
        },
        {
            id: 5,
            videoId: "EhxCCEhNqUg",
            title: "🌟 Dj Zerone | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/EhxCCEhNqUg/maxresdefault.jpg",
        },
        {
            id: 6,
            videoId: "YR51tGyiH7k",
            title: "🌟 Rafa Fernandes | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/YR51tGyiH7k/maxresdefault.jpg",
        },
        {
            id: 7,
            videoId: "FC4DJ1GveKQ",
            title: "🚀 Norberto Loco | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/FC4DJ1GveKQ/maxresdefault.jpg",
        },
        {
            id: 8,
            videoId: "kqKkqElE7V4",
            title: "🚀 K.LED | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/kqKkqElE7V4/maxresdefault.jpg",
        },
        {
            id: 9,
            videoId: "TIrHAHQLd6k",
            title: "🚀 Labi Ramaj | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/TIrHAHQLd6k/maxresdefault.jpg",
        },
        {
            id: 10,
            videoId: "tciAh317sOE",
            title: "🌟 BASICZ b2b NOTUNE | Freaks Of Nature E5: Querencia | Full Set - RELIVE",
            thumbnail: "https://img.youtube.com/vi/tciAh317sOE/maxresdefault.jpg",
        },
    ]);

    const filteredVideos = videos.filter((video) =>
        video.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const [showFilters, setShowFilters] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(videos[0]);

    const { isArabic } = useLanguage();

    const handleToggle = () => {
        setShowFilters(!showFilters);
    };

    return (
        <>
            <div className={`relive-section ${isArabic ? 'rtl' : 'ltr'}`}>
                <div className="relive-div">
                    <div className="relive-search">
                        {/* Main Search Bar */}
                        {!showFilters && (
                            <div className="search-bar-container">
                                <FaSearch className="search-icon" />
                                <input
                                    type="text"
                                    placeholder={isArabic ? "بحث" : "Search"}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="search-bar"
                                />
                            </div>
                        )}

                        {/* Filter and Secondary Search Bar */}
                        <div
                            className="filter-responsive-bar"
                            style={{
                                width: showFilters ? "100%" : "24px",
                                backgroundColor: showFilters ? "#000" : "transparent",
                            }}
                        >
                            {showFilters && (
                                <div className="search-bar-container1">
                                    <FaSearch className="search-icon" />
                                    <input
                                        type="text"
                                        placeholder={isArabic ? "بحث" : "Search"}
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="search-bar"
                                    />
                                </div>
                            )}

                            <FaFilter
                                className="filter-icon"
                                onClick={handleToggle}
                                style={{ color: showFilters ? "#fff" : "#000" }}
                            />

                            {showFilters && (
                                <div className="relive-playlist-mobile">
                                    <h3>{isArabic ? "قائمة التشغيل" : "Playlist"}</h3>
                                    <div className="relive-playlist-content-div">
                                        {filteredVideos.map((video) => (
                                            <div 
                                                className="playlist-item" 
                                                key={video.id}
                                                onClick={() => {
                                                    setCurrentVideo(video);
                                                    setShowFilters(false);
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img src={video.thumbnail} alt="Video Thumbnail" />
                                                <div>
                                                    <p style={{ color: '#fff' }}>{video.title}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="relive-container">
                        <div className="relive-playlist">
                            <h3>{isArabic ? "قائمة التشغيل" : "Playlist"}</h3>
                            <div className="relive-playlist-div">
                                <div className="relive-playlist-search">
                                    <div className="filter-search-bar-div">
                                        <input
                                            type="text"
                                            placeholder={isArabic ? "البحث عن الفنانين" : "Search Artists"}
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className="filter-search-bar"
                                        />
                                        <FaSearch className="filter-search-icon" />
                                    </div>
                                </div>

                                <div className="relive-playlist-content">
                                    <div className="relive-playlist-content-div">
                                        {filteredVideos.map((video) => (
                                            <div 
                                                className="playlist-item" 
                                                key={video.id}
                                                onClick={() => setCurrentVideo(video)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img src={video.thumbnail} alt="Video Thumbnail" />
                                                <div>
                                                    <p>{video.title}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="relive-content">
                            <div className="relive-iframe-wrapper">
                                <iframe
                                    src={`https://www.youtube.com/embed/${currentVideo.videoId}?autoplay=1`}
                                    allowFullScreen
                                    title="Video Player"
                                    allow="autoplay"
                                ></iframe>
                            </div>
                            <div className="relive-content-text">
                                <h2>{currentVideo.title}</h2>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default Relive;